module.exports = __webpack_public_path__ + "img/mdxg.41bd853d.png";